import {
  configure,
  extend,
  localeChanged,
  ValidationObserver,
  ValidationProvider
} from "vee-validate";
import { alpha_spaces, email, required } from "vee-validate/dist/rules";
import Vue from "vue";
import { checkPublicEmailDomains } from "../helpers";
extend("required", required);
extend("email", email);
extend("public_email", {
  validate: (value) => !checkPublicEmailDomains(value)
});
extend("alpha_spaces", alpha_spaces);
extend("phone", {
  validate: (value) => /^\+?\d{8,}$/.test(value)
});
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
var vee_validate_default = ({ app }) => {
  configure({
    defaultMessage: (field, values) => {
      values._field_ = app.i18n.t(`${field}`);
      return app.i18n.t(`validation_${values._rule_}`, values);
    }
  });
  app.i18n.onLanguageSwitched = () => {
    localeChanged();
  };
};
export {
  vee_validate_default as default
};
